export default {
	POST_REGISTER: () => "/auth/register",
	POST_MAGIC_LINK: () => "/auth/magicLink",
	GET_MAGIC_LINK: () => "/auth/magicLink",
};
